angular.module('unergie.main')
.controller('ogcCampaignsCtrl', ($scope, $state, BoFeaturesService, AlertManager, ModalService, TableGeneratorService, OGC, ErrorCatcher) => {
    $scope.campaigns = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'ID', mode: 'search_operator' },
            'name': { label: 'Libellé', mode: 'search_wildcard' },
            'creation_ts': { label: 'Date de création', mode: 'search_date' },
            'contactList.name': { label: 'Contacts', mode: 'search_wildcard' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.campaigns, 'ogc-campaigns', 'contactList', null, { orderBy: 'name' })

    $scope.openContactListModal = (cl, e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        ModalService.openModal({ type: 'ogcContactListsModal', size: 'xlg', backdrop: 'static' }, { contactList: cl && _.omit(cl, ['expanded']) })
    }

    $scope.openCampaignModal = (campaign) => {
        ModalService.openModal({ type: 'ogcCampaignModal', size: 'xlg', backdrop: 'static' }, { campaign: campaign && _.omit(campaign, ['expanded']) }, $scope.refresh)
    }

    $scope.deleteList = (campaign) => {
        return OGC.deleteCampaign({ id: campaign.id }).$promise.then(() => {
            AlertManager.success(`Liste supprimée`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.duplicateList = (campaign) => {
        const newOne = _.cloneDeep(campaign)
        newOne.name = `${newOne.name} duplicata`
        return OGC.addCampaign(_.omit(newOne, ['id', 'expanded', 'contactList'])).$promise.then(() => {
            AlertManager.success(`Campagne dupliquée : ${newOne.name}`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.toggleExpand = (campaign) => {
        campaign.expanded = !campaign.expanded
    }

    $scope.refresh()
})
